import { useStyle } from "../style";
import { SvgIcon, Theme } from "@mui/material";
import cardIconImg from "@static/img/icons/card.svg";

interface IParams {
    getColor?(theme: Theme): string;
}

export const CardIcon = (props: IParams) => {
    const { getColor } = props;
    const { classes } = useStyle({ getColor });

    return <SvgIcon className={classes.iconBox} component={cardIconImg} viewBox="0 0 30 30" />;
};
